import { ratingRequestAvailable } from 'shared/functions';

export const ratingRequestParser = items =>
  items
    .map(item => item[0])
    .filter(item => ratingRequestAvailable(item[1]))
    .map(item => ({
      id: item[0],
      level: item[1].l5 && item[1].l5.available ? 'L5' : 'L4',
    }));
